import { useFlags } from "launchdarkly-react-client-sdk";
import _isNumber from "lodash-es/isNumber";

import { FeatureFlag } from "featureFlags/constants";
import { FlagsInterface } from "featureFlags/hooks/useAllFlags";

export const useCreditsValue = () => {
  const flags = useFlags<Partial<FlagsInterface>>();
  const value = flags[FeatureFlag.FireboltAppCreditsValue];
  return value && _isNumber(value) ? value : 200;
};
